import React, { useEffect, useRef } from "react";
import { Animated, StyleProp, StyleSheet } from "react-native";

export interface UniSkeletonProps {
  shape?: "round" | "text";
  style?: StyleProp<any>;
}

export const UniSkeleton: React.FC<UniSkeletonProps> = (props) => {
  const { shape = "text" } = props;

  const opacity = useRef(new Animated.Value(0.3));

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity.current, {
          toValue: 1,
          useNativeDriver: true,
          duration: 500,
        }),
        Animated.timing(opacity.current, {
          toValue: 0.5,
          useNativeDriver: true,
          duration: 800,
        }),
      ])
    ).start();
  }, [opacity]);

  let style = { ...styles.base, ...props.style, opacity: opacity.current };
  if (shape === "round") {
    style = { ...style, ...styles.round };
  }

  return <Animated.View style={style} />;
};

const styles = StyleSheet.create({
  base: {
    borderRadius: 3,
    backgroundColor: "#E8EBEE",
  },
  round: {
    borderRadius: 100,
  },
});
